import React from 'react';
import { LabelText } from '../../components/Language';
import HeaderTitle from '../../hoc/HeaderTitle';
import './ReportsHeader.css';

export default function ReportsHeader(props) {  
    return (        
        <HeaderTitle className = "reports-header-code-row row">
          <span className="reports-header-title-align">
            <LabelText tid="reports" />
          </span>
          <span className="reports-header-code-align">
            {props.BusinessPartnerCode}
          </span>
        </HeaderTitle>        
    )
}  